import TagManager from 'react-gtm-module';

export interface TrackBuyBoxEventProps {
  eventName: string;
  linkText: string;
  linkUrl: string | null;
}

export const trackBuyBoxEvent = ({
  eventName,
  linkText,
  linkUrl,
}: TrackBuyBoxEventProps) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: eventName,
      interaction: {
        interaction_location: 'buy box',
        link_url: linkUrl,
        link_text: linkText,
      },
    },
  });
};
